import { PUBLIC_URL_ROOT } from '../../constants/urls';
import { compile } from 'path-to-regexp';
import addAgentSlugSubdomainToDomain from './addAgentSlugSubdomainToDomain';
import isDefinedAndNonNull from '../../utils/isDefinedAndNonNull';

export default function createDeepLink(
  route: string,
  routeParameters:
    | { [key: string]: string | undefined | null }
    | { agentSlug?: string },
  queryParameters?: { [key: string]: string | undefined | null } | null,
): string {
  const routeWithParametersReplaced = compile(route)(routeParameters);
  let domain =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001'
      : PUBLIC_URL_ROOT;
  if (routeParameters.agentSlug) {
    // add agentSlug to the subdomain
    domain = addAgentSlugSubdomainToDomain(domain, routeParameters.agentSlug);
  }

  const deepLink = new URL(routeWithParametersReplaced, domain);

  const queryParams = new URLSearchParams(deepLink.search);
  for (const key in queryParameters) {
    const value = queryParameters[key];
    if (isDefinedAndNonNull(value)) {
      queryParams.append(key, value);
    }
  }
  deepLink.search = queryParams.toString();

  return deepLink.toString();
}
